import { useState } from "react";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

export const FanWorkFields = ({ story, meta }) => {
  const [source, setSource] = useState(story.fan_source || "");
  const toggle = (v) => {
    if (v && !source.trim()) { toast.info("First name the original work it's based on"); return document.getElementById("fan-source-input")?.focus(); }
    meta({ fan_work: v, fan_source: source }, v ? "Marked as a fan work" : "Fan-work label removed");
  };
  return (
    <div className="space-y-2 rounded border border-[#2D3442] p-3" data-testid="fan-work-fields">
      <label className="flex items-center gap-2 text-sm text-[#F3EBDD]"><Switch checked={!!story.fan_work} onCheckedChange={toggle} data-testid="fan-work-toggle" />This is a fan work</label>
      <div className="flex gap-2">
        <Input id="fan-source-input" value={source} onChange={(e) => setSource(e.target.value)} placeholder="Based on, e.g. The Lord of the Rings" maxLength={120} data-testid="fan-source-input" />
        <Button size="sm" variant="outline" disabled={!source.trim() || source.trim() === (story.fan_source || "")} onClick={() => meta({ fan_work: true, fan_source: source }, "Fan-work credit saved")} data-testid="fan-source-save">Save</Button>
      </div>
      <p className="text-[11px] leading-relaxed text-[#7A7468]">Readers see a “Fan work” tag and a credit to the original. Fan works are for sharing, not selling. See the terms.</p>
    </div>
  );
};

export const RightsHoldNotice = () => (
  <div className="flex gap-2 rounded border border-[#EF4444]/40 bg-[#EF4444]/10 p-3 text-xs leading-relaxed text-[#FCA5A5]" data-testid="rights-hold-notice">
    <ShieldAlert className="h-4 w-4 shrink-0" />This story was removed from Reader Mode after a rights report. Your private copy is safe. Reply to our email if you think this is a mistake.
  </div>
);
